// Admin > Data: data exports and account closure (ADR 0062), through the shared ClosureApi.
import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";
import { type ApiClient, ClosureApi } from "@vd/api-client";
import { transport } from "./transport";

// ClosureApi takes the full ApiClient, though it calls only get, post and del, which the
// console's transport has.
export const closureApi = new ClosureApi(transport as unknown as ApiClient);

export const closureKeys = {
  exports: ["admin", "exports"] as const,
  closure: ["admin", "closure"] as const,
  preview: ["admin", "closure-preview"] as const,
};

export const exportsQuery = infiniteQueryOptions({
  queryKey: closureKeys.exports,
  queryFn: ({ pageParam, signal }) => closureApi.exports(pageParam, signal),
  initialPageParam: null as string | null,
  getNextPageParam: (last) => last.next_cursor,
});

export const closureQuery = queryOptions({
  queryKey: closureKeys.closure,
  queryFn: ({ signal }) => closureApi.closure(signal),
});

/** The close dialog's lines, read fresh each time it opens. */
export const closurePreviewQuery = queryOptions({
  queryKey: closureKeys.preview,
  queryFn: ({ signal }) => closureApi.closurePreview(signal),
  staleTime: 0,
  gcTime: 0,
});
